import React from 'react';
import Header from '@/lighting-app/components/Header';
import DesignWizardClient from './components/DesignWizardClient';

export default function DesignNewLightingPage() {
  return (
    <div className="min-h-screen flex flex-col bg-background">
      <Header />
      <main className="flex-1 pt-20">
        <DesignWizardClient />
      </main>
    </div>
  );
}